import { PageRequest } from '@/core/request/PageRequest';
import { Model } from '../BrandsModelsVersions/BrandsModelsVersions.types';
import { Color } from '../Colors/Colors.types';
import { Fuel } from '../Fuels/Fuels.types';

export enum VehicleType {
  SUV = 'SUV',
  SEDAN = 'SEDAN',
  HATCH = 'HATCH',
  PICKUP = 'PICKUP',
  TRUCK = 'TRUCK',
  BOX_TRUCK = 'BOX_TRUCK',
  MOTO_NAKED = 'MOTO_NAKED',
  MOTO_SCOOTER = 'MOTO_SCOOTER',
}

export interface CustomerVehicle {
  active: boolean;
  chassi: string;
  color: Color;
  customerId: number;
  customerName: string;
  fuel: Fuel;
  id: number;
  km: number;
  averageKm?: number;
  licensePlate: string;
  cylinders?: string;
  engineCapacity?: string;
  engineName?: string;
  engineTechnicalCode?: string;
  hasMissingData: boolean;
  horsePower?: string[];
  image?: string;
  release?: string;
  valves?: string;
  model: Model;
  fleet?: string;
  renavam: string;
  type?: VehicleType;
  yearFabrication: number;
  yearModel: number;
  accessories: {
    id: number;
    description: string;
  }[];
  line?: string;
  airIntake?: string;
  rearBrake?: string;
  frontBrake?: string;
  brakeSystem?: string;
  steeringSystem?: string;
  tractionSystem?: string;
  injectionSystem?: string;
  transmissionType?: string;
  engineConfiguration?: string;
}

export interface CustomerVehicleReduced {
  brandName: string;
  customerId: number;
  id: number;
  km?: number;
  licensePlate: string;
  active?: boolean;
  modelName: string;
  yearFabrication: number;
  yearModel: number;
  fuel: Fuel;
}

export interface CreateCustomerVehicleRequest {
  active: boolean;
  chassi?: string;
  color: {
    id: number;
  };
  fuel: {
    id: number;
  };
  km?: number;
  averageKm?: number;
  licensePlate: string;
  fleet?: string;
  model: {
    id: number;
    brand: {
      id: number;
      image?: string;
    };
  };
  renavam?: string;
  type?: VehicleType;
  yearFabrication: number;
  yearModel: number;
  accessories: {
    id: number;
    description: string;
    vehicleId?: number;
  }[];
  customerId?: number;
  cylinders?: string;
  engineCapacity?: string;
  engineName?: string;
  engineTechnicalCode?: string;
  horsePower?: string[];
  image?: string;
  release?: string;
  valves?: string;
  line?: string;
  airIntake?: string;
  rearBrake?: string;
  frontBrake?: string;
  brakeSystem?: string;
  steeringSystem?: string;
  tractionSystem?: string;
  injectionSystem?: string;
  transmissionType?: string;
  engineConfiguration?: string;
}

export interface UpdateCustomerVehicleRequest {
  id: number;
  active: boolean;
  chassi?: string;
  color: {
    id: number;
  };
  fuel: {
    id: number;
  };
  customerId?: number;
  km?: number;
  licensePlate: string;
  fleet?: string;
  model: {
    id: number;
    brand: {
      id: number;
    };
  };
  renavam?: string;
  yearFabrication: number;
  yearModel: number;
  accessories: {
    id: number;
    description: string;
  }[];
}

export interface ListCustomerVehiclesFilterParams {
  active?: boolean;
  chassi?: string;
  licensePlate?: string;
  modelId?: number;
  nextToken?: string;
  rows?: number;
}

export interface CustomerVehiclesFilterParamsReduced extends PageRequest {
  brandId?: number;
  customerId?: number;
  active?: boolean;
  chassi?: string;
  licensePlate?: string;
  modelId?: number;
  customerActive?: boolean;
}

export interface ChangeVehicleOwnershipRequestInterface {
  idNewCustomer: number;
  idOldCustomer: number;
  oldVehicleId: number;
  newVehicleId?: number;
}

export interface VehicleFormData {
  vehicleId?: number;
  licensePlate: string;
  brandId: number;
  brandName?: string;
  modelId: number;
  modelName?: string;
  yearFabrication: string;
  yearModel: string;
  fuelId: number;
  colorId: number;
  renavam?: string;
  chassi?: string;
  km?: number;
  averageKm?: number;
  imageUpload?: File;
  model: Model;
  accessories?: string[];
  fleet?: string;
  customerId?: number;
  color?: Color;
  type?: VehicleType;
  cylinders?: string;
  engineCapacity?: string;
  engineName?: string;
  engineTechnicalCode?: string;
  horsePower?: string[];
  image?: string;
  release?: string;
  valves?: string;
  line?: string;
  airIntake?: string;
  rearBrake?: string;
  frontBrake?: string;
  brakeSystem?: string;
  steeringSystem?: string;
  tractionSystem?: string;
  injectionSystem?: string;
  transmissionType?: string;
  engineConfiguration?: string;
}

export interface VehicleEnrichRequest {
  customerId: number;
  vehicleId: number;
}
